// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"944":"bac617a3","945":"0b46f1d9"}[chunkId] + ".chunk.js";
};